import { render, staticRenderFns } from "./threeDimensional.vue?vue&type=template&id=f6ef04a6&scoped=true"
import script from "./threeDimensional.vue?vue&type=script&lang=js"
export * from "./threeDimensional.vue?vue&type=script&lang=js"
import style0 from "./threeDimensional.vue?vue&type=style&index=0&id=f6ef04a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ef04a6",
  null
  
)

export default component.exports